import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import CallDetailsTabs from "../../calldetails/components/CallDetailsTabs";

const CallDetailsquote = () => {
  const { id } = useParams();

  const { cdnURL, adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual
  );

  const [isLoading, setIsLoading] = useState(true);
  const [quoteObj, setQuoteObj] = useState({});
  const [callItems, setCallItems] = useState([]);

  const handleClose = () => {
    const canClose = window.opener || window.history.length <= 1;
    if (canClose) {
      window.close();
    } else {
      window.location.assign('/quote');
    }
  };

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        const { data } = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_HOST}${adminBaseURL}/quote/getCallDetailsQuote/${id}`,
          headers: { "Content-Type": "application/json" },
        });
        if (!mounted) return;
        if (data && data.code === 200 && data.data) {
          setQuoteObj(data.data.quote || {});
          setCallItems(Array.isArray(data.data.call_ai) ? data.data.call_ai : []);
        } else {
          setQuoteObj({});
          setCallItems([]);
        }
      } catch (e) {
        setQuoteObj({});
        setCallItems([]);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [id, adminBaseURL]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div style={{ background: "#f3f4f6", height: "calc(100vh - 160px)", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <div
          style={{
            background: "#ffffff",
            borderRadius: 16,
            boxShadow: "0 15px 40px rgba(15, 23, 42, 0.08)",
            border: "1px solid #e5e7eb",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            flex: 1,
            minHeight: 0,
          }}
        >
          <div
            style={{
              padding: "20px 28px 12px",
              borderBottom: "1px solid #e5e7eb",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12, position: "relative" }}>
              <div style={{ fontSize: 20, fontWeight: 600 }}>Quote Call Details</div>
              <button
                type="button"
                className="btn"
                onClick={handleClose}
                style={{
                  backgroundColor: "#fff",
                  color: "#991b1b",
                  borderRadius: 999,
                  boxShadow: "none",
                  fontWeight: 600,
                  minWidth: "auto",
                  border: "none",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: 30,
                  width: 30,
                  padding: 0,
                  position: "absolute",
                  top: -17,
                  right: -25,
                }}
              >
                <span style={{ color: "#ef4444", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <SVG src={toAbsoluteUrl("/media/svg/icons/custom/Close.svg")} height={30} width={30} />
                </span>
              </button>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Name</div>
                <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.name || "-"}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Email</div>
                <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.email || "-"}</div>
              </div>
              <div>
                <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Mobile</div>
                <div style={{ fontWeight: 600, color: "#111827" }}>{quoteObj?.contactNumber || "-"}</div>
              </div>
            </div>
          </div>

          <div style={{ padding: 24, background: "#f8fafc", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div
              style={{
                background: "#ffffff",
                borderRadius: 12,
                border: "1px solid #e5e7eb",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: 0,
              }}
            >
              <CallDetailsTabs
                callItems={callItems}
                cdnURL={cdnURL}
                emptyMessage="No AI call records available for this quote."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallDetailsquote;


